export function getAppDomain() {
  const hostname = window.location.hostname;
  
  // Check if we're on a custom domain
  if (!hostname.includes('printshoppricing.com')) {
    return hostname;
  }

  // Check if we're on the app subdomain
  if (hostname.startsWith('app.')) {
    return 'app.printshoppricing.com';
  }

  // Main domain
  return 'printshoppricing.com';
}

export function shouldRedirect() {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  
  // Don't redirect on custom domains
  if (!hostname.includes('printshoppricing.com')) {
    return false;
  }

  // Admin routes should be on app subdomain
  if (pathname.startsWith('/admin')) {
    return hostname !== 'app.printshoppricing.com';
  }

  // Calculator routes should be on app subdomain
  if (pathname !== '/' && pathname !== '/pricing') {
    return hostname !== 'app.printshoppricing.com';
  }

  // Main site routes should be on main domain
  return hostname !== 'printshoppricing.com';
}

export function getRedirectUrl() {
  const { pathname, search, hash } = window.location;
  const hostname = window.location.hostname;
  
  // Determine target domain
  const targetDomain = pathname.startsWith('/admin') || 
    (pathname !== '/' && pathname !== '/pricing')
    ? 'app.printshoppricing.com'
    : 'printshoppricing.com';

  // Only change domain if needed
  if (hostname === targetDomain) return null;

  return `https://${targetDomain}${pathname}${search}${hash}`;
}